export const PHONE_NUMBER_ECOGOLD = "021-82800860";

export const ADDRESS_ECOGOLD =
  "بازار تهران ناصر خسرو پاساژ شمس العماره واحد418";

export const GA_TRACKING_ID = "G-KBGTBXY7KB";

export const CLARITY_PROJECT_ID = "pont6c4unm";

export const GOLD18_IRT_SYMBOL = "GOLD18-IRT";

export const IRT_SYMBOL = "IRT";

export const GOLD_SYMBOL = "GOLD18";
